import { Card } from 'components/ui'
import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'

function HowItWorks() {
    const { t } = useTranslation()
    return (
        <Fragment>
            <Card className="mb-20">
                <section className="how-it-works flex flex-col justify-center items-center gap-10 py-10">
                    <div className="hw">
                        <h1
                            className="hw__heading"
                            dangerouslySetInnerHTML={{
                                __html: t('home:content.howItWork.h1'),
                            }}
                        />
                    </div>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: t('home:content.howItWork.body'),
                        }}
                    />
                </section>
            </Card>
        </Fragment>
    )
}

export default HowItWorks
